const initSearchCondition = {
  duplicateIdentificationCheckHistoryId: '',
}
const clickSearchCondition = {
  duplicateIdentificationCheckHistoryId: '',
  duplicateIdentificationCheckHistoryItemId: '',
}
export {initSearchCondition, clickSearchCondition};